import React from 'react'
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const WebhookContent = () => {

  const validate = Yup.object({
    webhook: Yup.string()
        .min(3)
    
  })

  return (

    <div>

        <Formik

          initialValues={{ 
              webhook: '',
          }}

          validationSchema={validate}

          onSubmit = {( values ) => {
            console.log('Form values', values)
          }}
        >
          {formik => (

            <div className="form__control webhook__form__control">
                <Form action="#"> 

                    <label htmlFor="webhook">Webhook URL</label>
                    <input 
                      className='webhook__input input__layer__two' 
                      type="text" 
                      name="webhook" 
                      placeholder='webhook URL' 
                    />


                    <input className='__btn' type="submit" value='Save' />
                    
                </Form>
            </div>
        )}              
      </Formik>
    </div>
  )
}

export default WebhookContent